"use strict";

// From Alfrosco Config
let _channelName = "";
let _queues = "";
let _timeToDisplay = "";
let _hideOnPages = "";
let _isLoggingOn = "";

let _chatActive = false;
let _userName = "";
let _userEmail = "";
let _partnerId = "";
let _agentName = "";
let _chatWindowOpen = false;
let _chatId = "";
let _chatSurveyId = "";
let _pageId = "";
let _aemPage = "";
// Variable to hold number of unseen messages by customer.
let _unreadMessagesCount = 0;
// Flag to indicate if the time out warning or timed out message have not been seen by customer yet.
// 0 means it has already been seen or hasn't happened yet, 1 means warning, 2 means already timed out.
let _warningDisplayFlag = 0;

let _accessTokenValue = "";

// TODO - This flag will need to be reset to false when queue message shown and when user starts chat and also ends chat.
let _resetQueueMessageFlag = false;
// TODO - Need to clear this when user enters session and exits.
let _queueEventTimeout;
// Array to store interval Id's when checking for messages received.
let _eventIntervalIds = [];
// Variable to hold the number of agents/supervisors connected to a chat.
let _nbrConnectedAgents;
// Variable to hold authentication flag.
let _isAuthenticated = false;
// Variable to hold webChatSurvey feedback active flag
let _isFeedBackActive = false;
// Variable to hold 2FA active flag
let _is2FAActive = false;
// Variable to hold minimised flag
let _chatWindowMinimised = false;

// ENUM holding external links that can be accessed from the Portal application.
const _EXT_LINKS = { MYVHI: 1, MYVHILOGOUT: 2 };

// Flag will indicate if queue message was already shown to user in this chat session to prevent it being shown again.
let _queueMessageAlreadyShown = false;

// List of different states the Web Chat Client can be in.
const _STATE_CLOSED = 0; // User has not clicked on Web Chat so everything is minismised.
const _STATE_OPEN_ENTER_NAME = 1; // Window open but waiting on user to enter name
const _STATE_OPEN_AGENTS_OFFLINE = 2; // Window open but all users have gone offline
const _STATE_OPEN_QUEUE = 3; // Window open but user waiting in queue
const _STATE_OPEN_ACTIVE_WEB_CHAT = 4; // Window open and user in an active chat
const _STATE_OPEN_TIMEOUT_WARNING = 5; // Window open and initial system timeout warning
const _STATE_OPEN_TIMED_OUT = 6; // Window open and system has timed out chat session
const _STATE_OPEN_END_CONFIRM = 7; // Window open and user has clicked end icon and showing confirm end questions.
const _STATE_OPEN_ENDED = 8; // Window open and user has ended chat with or without requesting a transcript.
const _STATE_OPEN_TRANSCRIPT_EMAIL = 9; // Window open and user needs to enter email for transcript
const _STATE_OPEN_ENDED_TRANSCRIPT_SENT = 10; // Window open and user has ended chat requesting a transcript.
const _STATE_CLOSED_BUBBLE_ONLY = 11; // Window closed and hidden and only bubble shown.
const _STATE_LEAVING_PORTAL = 12; // User has clicked on MyVhi link so show message that chat will end.
const _STATE_OPEN_FEEDBACK = 13; // Window open and user need to give feedback
const _STATE_OPEN_PIN_REQUEST = 14;
const _STATE_CLOSE_PIN_REQUEST = 15;
const _STATE_OPEN_MINIMISED = 16; // Window is minimised and unread messages icon displaying.

const nbrConnectedAgents = () => {
  // return counter if variable is a number, otherwise return zero.
  if (isNaN(_nbrConnectedAgents)) {
    return 0;
  } else {
    return _nbrConnectedAgents;
  }
};

const setChannelName = (channelName) => {
  _channelName = channelName;
};

const setTimeToDisplay = (timeToDisplay) => {
  _timeToDisplay = timeToDisplay;
};

const setHideOnPages = (hideOnPages) => {
  _hideOnPages = hideOnPages;
};

const setIsLoggingOn= (isLoggingOn) => {
  _isLoggingOn = isLoggingOn;
};

const setQueues = (queues) => {
  _queues = queues;
};

const setChatActive = (flag) => {
  _chatActive = flag;
};

const setUserName = (inUserName) => {
  _userName = inUserName;
};

const setUserEmail = (inUserEmail) => {
  _userEmail = inUserEmail;
};

const setPartnerId = (inPartnerid) => {
  _partnerId = inPartnerid;
};

const setAgentName = (inAgentName) => {
  _agentName = inAgentName;
};

const setChatWindowOpen = (inChatWindowOpen) => {
  _chatWindowOpen = inChatWindowOpen;
};

const setEventIntervalIds = (inEventIntervalIds) => {
  _eventIntervalIds = inEventIntervalIds;
};

const setUnreadMessagesCount = (inUnreadMessagesCount) => {
  _unreadMessagesCount = inUnreadMessagesCount;
};

const setWarningDisplayFlag = (warningDisplayFlag) => {
  _warningDisplayFlag = warningDisplayFlag;
};

const setNbrConnectedAgents = (nbrConnectedAgents) => {
  _nbrConnectedAgents = nbrConnectedAgents;
};

const setIsAuthenticated = (isAuthenticated) => {
  _isAuthenticated = isAuthenticated;
};

const setFeedBackActive = (isActive) => {
  _isFeedBackActive = isActive;
};

const setChatId = (chatId) => {
  _chatId = chatId;
};

const setChatSurveyId = (chatSurveyId) => {
  _chatSurveyId = chatSurveyId;
};

const setPageId = (pageId) => {
  _pageId = pageId;
};

const setAemPage = (aemPage) => {
  _aemPage = aemPage;
};

const setResetQueueMessageFlag = (resetQueueMessageFlag) => {
  _resetQueueMessageFlag = resetQueueMessageFlag;
};

const setQueueMessageAlreadyShown = (queueMessageAlreadyShown) => {
  _queueMessageAlreadyShown = queueMessageAlreadyShown;
};

const setQueueEventTimeout = (queueEventTimeout) => {
  _queueEventTimeout = queueEventTimeout;
};

const set2FAActive = (isActive) => {
  _is2FAActive = isActive;
};

const setAccessTokenValue = (accessTokenValue) => {
  _accessTokenValue = accessTokenValue;
};

const chatActive = () => {
  return _chatActive;
};

const channelName = () => {
  return _channelName;
};

const queues = () => {
  return _queues;
};

const timeToDisplay = () => {
  return _timeToDisplay;
};

const hideOnPages = () => {
  return _hideOnPages;
};

const isLoggingOn = () => {
  return _isLoggingOn;
};

const userName = () => {
  return _userName;
};

const userEmail = () => {
  return _userEmail;
};

const partnerId = () => {
  return _partnerId;
};

const agentName = () => {
  return _agentName;
};

const chatWindowOpen = () => {
  return _chatWindowOpen;
};

const webChatWindowMinimised = () => {
  return _chatWindowMinimised;
};
const setWebChatWindowMinimised = (flag) => {
  _chatWindowMinimised = flag;
};

const unreadMessagesCount = () => {
  return _unreadMessagesCount;
};

const eventIntervalIds = () => {
  return _eventIntervalIds;
};

const warningDisplayFlag = () => {
  return _warningDisplayFlag;
};

const isAuthenticated = () => {
  return _isAuthenticated;
};

const isFeedBackActive = () => {
  return _isFeedBackActive;
};

const chatId = () => {
  return _chatId;
};

const chatSurveyId = () => {
  return _chatSurveyId;
};

const pageId = () => {
  return _pageId;
};

const aemPage = () => {
  return _aemPage;
};

const resetQueueMessageFlag = () => {
  return _resetQueueMessageFlag;
};

const isQueueMessageAlreadyShown = () => {
  return _queueMessageAlreadyShown;
};

const queueEventTimeout = () => {
  return _queueEventTimeout;
};

const is2FAActive = () => {
  return _is2FAActive;
};

const accessTokenValue = () => {
  return _accessTokenValue;
};

const STATE_CLOSED = () => {
  return _STATE_CLOSED; 
};

const STATE_OPEN_ENTER_NAME = () => {
  return _STATE_OPEN_ENTER_NAME;            
};

const STATE_OPEN_AGENTS_OFFLINE = () => {
  return _STATE_OPEN_AGENTS_OFFLINE;
};

const STATE_OPEN_QUEUE = () => {
  return _STATE_OPEN_QUEUE; 
};

const STATE_OPEN_ACTIVE_WEB_CHAT = () => {
  return _STATE_OPEN_ACTIVE_WEB_CHAT; 
};

const STATE_OPEN_TIMEOUT_WARNING = () => {
  return _STATE_OPEN_TIMEOUT_WARNING; 
};

const STATE_OPEN_TIMED_OUT = () => {
  return _STATE_OPEN_TIMED_OUT; 
};

const STATE_OPEN_END_CONFIRM = () => {
  return _STATE_OPEN_END_CONFIRM; 
};

const STATE_OPEN_ENDED = () => {
  return _STATE_OPEN_ENDED; 
};

const STATE_OPEN_TRANSCRIPT_EMAIL = () => {
  return _STATE_OPEN_TRANSCRIPT_EMAIL; 
};

const STATE_OPEN_ENDED_TRANSCRIPT_SENT = () => {
  return _STATE_OPEN_ENDED_TRANSCRIPT_SENT; 
};

const STATE_CLOSED_BUBBLE_ONLY = () => {
  return _STATE_CLOSED_BUBBLE_ONLY; 
};


const STATE_LEAVING_PORTAL = () => {
  return _STATE_LEAVING_PORTAL; 
};

const STATE_OPEN_FEEDBACK = () => {
  return _STATE_OPEN_FEEDBACK; 
};

const STATE_OPEN_PIN_REQUEST = () => {
  return _STATE_OPEN_PIN_REQUEST; 
};

const STATE_CLOSE_PIN_REQUEST = () => {
  return _STATE_CLOSE_PIN_REQUEST; 
};

const EXT_LINKS = () => {
  return _EXT_LINKS; 
};

const STATE_OPEN_MINIMISED = () => {
  return _STATE_OPEN_MINIMISED;
};

module.exports = {
  STATE_CLOSED: STATE_CLOSED,
  STATE_OPEN_ENTER_NAME: STATE_OPEN_ENTER_NAME,
  STATE_OPEN_AGENTS_OFFLINE: STATE_OPEN_AGENTS_OFFLINE,
  STATE_OPEN_QUEUE: STATE_OPEN_QUEUE,
  STATE_OPEN_ACTIVE_WEB_CHAT: STATE_OPEN_ACTIVE_WEB_CHAT,
  STATE_OPEN_TIMEOUT_WARNING: STATE_OPEN_TIMEOUT_WARNING,
  STATE_OPEN_TIMED_OUT: STATE_OPEN_TIMED_OUT,
  STATE_OPEN_END_CONFIRM: STATE_OPEN_END_CONFIRM,
  STATE_OPEN_ENDED: STATE_OPEN_ENDED,
  STATE_OPEN_TRANSCRIPT_EMAIL: STATE_OPEN_TRANSCRIPT_EMAIL,
  STATE_OPEN_ENDED_TRANSCRIPT_SENT: STATE_OPEN_ENDED_TRANSCRIPT_SENT,
  STATE_CLOSED_BUBBLE_ONLY: STATE_CLOSED_BUBBLE_ONLY,
  STATE_LEAVING_PORTAL: STATE_LEAVING_PORTAL,
  STATE_OPEN_FEEDBACK: STATE_OPEN_FEEDBACK,
  STATE_OPEN_PIN_REQUEST: STATE_OPEN_PIN_REQUEST,
  STATE_CLOSE_PIN_REQUEST: STATE_CLOSE_PIN_REQUEST,
  EXT_LINKS: EXT_LINKS,
  STATE_OPEN_MINIMISED: STATE_OPEN_MINIMISED,

  chatActive: chatActive,
  setChatActive: setChatActive,
  channelName: channelName,
  setChannelName: setChannelName,
  setQueues: setQueues,
  queues: queues,
  setTimeToDisplay: setTimeToDisplay,
  timeToDisplay: timeToDisplay,
  setHideOnPages: setHideOnPages,
  hideOnPages: hideOnPages,
  setIsLoggingOn: setIsLoggingOn,
  isLoggingOn: isLoggingOn,
  userName: userName,
  setUserName: setUserName,
  userEmail: userEmail,
  setUserEmail: setUserEmail,
  partnerId: partnerId,
  setPartnerId: setPartnerId,
  agentName: agentName,
  setAgentName: setAgentName,
  chatWindowOpen: chatWindowOpen,
  setChatWindowOpen: setChatWindowOpen,
  webChatWindowMinimised: webChatWindowMinimised,
  setWebChatWindowMinimised: setWebChatWindowMinimised,
  eventIntervalIds: eventIntervalIds,
  setEventIntervalIds: setEventIntervalIds,
  unreadMessagesCount: unreadMessagesCount,
  setUnreadMessagesCount: setUnreadMessagesCount,
  warningDisplayFlag: warningDisplayFlag,
  setWarningDisplayFlag: setWarningDisplayFlag,
  nbrConnectedAgents: nbrConnectedAgents,
  setNbrConnectedAgents: setNbrConnectedAgents,
  setIsAuthenticated: setIsAuthenticated,
  isAuthenticated: isAuthenticated,
  setFeedBackActive: setFeedBackActive,
  isFeedBackActive: isFeedBackActive,
  setChatId: setChatId,
  chatId: chatId,
  setChatSurveyId: setChatSurveyId,
  chatSurveyId: chatSurveyId,  
  setPageId: setPageId,
  pageId: pageId,
  setAemPage: setAemPage,
  aemPage: aemPage,
  setResetQueueMessageFlag: setResetQueueMessageFlag,
  resetQueueMessageFlag: resetQueueMessageFlag,
  setQueueMessageAlreadyShown: setQueueMessageAlreadyShown,
  isQueueMessageAlreadyShown: isQueueMessageAlreadyShown,
  setQueueEventTimeout: setQueueEventTimeout,
  queueEventTimeout: queueEventTimeout,
  set2FAActive: set2FAActive,
  is2FAActive: is2FAActive,
  setAccessTokenValue: setAccessTokenValue,
  accessTokenValue: accessTokenValue
};